import getEnvironmentName from './getEnvironmentName';

// Note: we use includes() here instead of strict equality check because
// we want to allow for environment names such as "prod-next" or "prod-2"
// to be treated as prod environments.
//
// Evaluated per call rather than memoized at module scope so that the result
// reflects the environment at the time it is asked for, not at the time this
// module happened to be evaluated (CON-8595).
const isProd = () => Boolean(getEnvironmentName()?.includes('prod'));

export default isProd;
